const { assoc, pipe } = require("ramda");

/**
 * Helper module to send a 400 - Bad Request HTTP response.
 */
module.exports = (ctx, err) => pipe(assoc("error", err), assoc("status", 400), ctx.error)({});
